<div class="flex-anadir">
  <div #botonAnadir>
    <app-boton-accion id="btnAnadirId" [icono]="'icon-plus'" [titulo]="'añadir campo'" (botonClicked)="getPosicion($event)"></app-boton-accion>
  </div>
</div>
<app-campos-temporal *ngFor="let campo of campoMoverArray" [posicionCampo]="posicionCampo"></app-campos-temporal>
